export default __webpack_public_path__ + "locales/es/DataReassignmentDialog.json?hash=fe087502b0afb1278088c9c12918f9a9";